
import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import NotFound from '../pages/NotFound';

const HomePage = lazy(() => import('../pages/home/page'));
const CatalogPage = lazy(() => import('../pages/catalog/page'));
const LivePage = lazy(() => import('../pages/live/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/catalogo',
    element: <CatalogPage />,
  },
  {
    path: '/en-vivo',
    element: <LivePage />,
  },
  {
    path: '/contacto',
    element: <ContactPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
